module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"addResult":"Add result","assignToMe":"Assign to me","removeConfirm":"Are you sure you want to delete this task?"},"et":{"addResult":"Add result","assignToMe":"Assign to me","removeConfirm":"Are you sure you want to delete this task?"},"ru":{"addResult":"Add result","assignToMe":"Assign to me","removeConfirm":"Are you sure you want to delete this task?"}}')
  delete Component.options._Ctor
}
